import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type SurfaceTreatmentsPredictionsDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.getSurfaceTreatmentsPredictions
>;

export const fetchSurfaceTreatmentsPredictions = async (
  quoteRequestLineId: string,
): Promise<SurfaceTreatmentsPredictionsDto | null> => {
  const response = await api.quoteRequestLines.getSurfaceTreatmentsPredictions.query({
    params: { id: quoteRequestLineId },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
